import { OnInit } from '@angular/core';
import { LivePreviewService } from '../../shared/services/live-preview.service';
import { LeadGenerationStylesService } from '../../shared/services/lead-generation-styles.service';
import { AmplitudeService } from '../../../shared/services/amplitude.service';
import { getActiveProjectSelector } from '../../projects/projects.reducer';
import { Store } from '@ngrx/store';
import { UpdateProjectStyleAction } from '../../projects/projects.action';
import { MatDialog } from '@angular/material';
import { ConfirmDialogComponent } from '../../../shared/dialog/confirm-dialog/confirm-dialog.component';
import { markFormAsTouched } from '../../shared/reactive-forms/forEachElementInForm';
var BubbleCreatorComponent = /** @class */ (function () {
    function BubbleCreatorComponent(livePreviewService, leadGenerationStylesService, dialog, amplitudeService, store) {
        this.livePreviewService = livePreviewService;
        this.leadGenerationStylesService = leadGenerationStylesService;
        this.dialog = dialog;
        this.amplitudeService = amplitudeService;
        this.store = store;
        this.popupSettings = this.leadGenerationStylesService.createBubbleForm();
    }
    BubbleCreatorComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.logAmplitude('Init');
        this.store.select(getActiveProjectSelector).subscribe(function (config) {
            _this.config = config;
            _this.leadGenerationStylesService.updateForm(_this.popupSettings, _this.config, 'bubble');
        });
        this.popupSettings.valueChanges.subscribe(function () { return _this.sendChanges(); });
    };
    BubbleCreatorComponent.prototype.sendChanges = function () {
        this.livePreviewService.sendToFrame('CHANGE_SETTINGS', this.popupSettings.value, undefined);
    };
    Object.defineProperty(BubbleCreatorComponent.prototype, "currentProjectId", {
        get: function () {
            return this.config.projectId;
        },
        enumerable: true,
        configurable: true
    });
    BubbleCreatorComponent.prototype.saveDb = function () {
        var _this = this;
        if (this.popupSettings.invalid) {
            this.logAmplitude('Invalid form', this.popupSettings.errors);
            markFormAsTouched(this.popupSettings);
            return;
        }
        this.logAmplitude('Confirming');
        this.dialog
            .open(ConfirmDialogComponent, {
            data: {
                title: 'LEAD_GENERATION.CONFIRMATION_TITLE',
                body: 'LEAD_GENERATION.CONFIRMATION_BUBBLE_INFO'
            }
        })
            .afterClosed()
            .subscribe(function (confirm) {
            if (confirm) {
                _this.amplitudeService.logEvent('Panel: Lead Generation: Bubble Published');
                _this.store.dispatch(new UpdateProjectStyleAction({
                    type: 'BUBBLE',
                    body: _this.popupSettings.value,
                    config: _this.config
                }));
            }
        });
    };
    BubbleCreatorComponent.prototype.onChangeEditorCode = function (code, formField) {
        this.popupSettings.get(formField).setValue(code);
    };
    BubbleCreatorComponent.prototype.logAmplitude = function (message, event) {
        this.amplitudeService.logEvent("Panel:WebCall:BubbleCreator: " + message, event);
    };
    return BubbleCreatorComponent;
}());
export { BubbleCreatorComponent };
